import { useEffect, useRef, useState } from "react";
import {
  redirectToHandoffTool,
  WebsiteHandoffError,
} from "../lib/websiteHandoff";

export function WebsiteHandoffRecovery({
  error,
  onRetry,
}: {
  error: WebsiteHandoffError;
  onRetry?: () => Promise<void>;
}) {
  const redirected = useRef(false);
  const [retrying, setRetrying] = useState(false);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    if (onRetry || redirected.current) return;
    redirected.current = true;
    redirectToHandoffTool(error.toolUrl);
  }, [error.toolUrl, onRetry]);
  if (onRetry)
    return (
      <div className="min-h-screen grid place-items-center p-6">
        <div className="max-w-md space-y-5">
          <h1 className="text-2xl font-semibold">Let’s restore your content</h1>
          <p role="alert" className="text-muted-foreground">
            {failed
              ? "We still couldn’t restore your content. Try again, or return to the tool to send it again."
              : "You’re signed in, but we couldn’t restore your content yet. Try again without signing up again."}
          </p>
          <div className="flex flex-wrap gap-3">
            <button
              className="rounded-md bg-brand px-5 py-3 font-medium text-brand-foreground"
              disabled={retrying}
              onClick={async () => {
                setRetrying(true);
                try {
                  await onRetry();
                } catch {
                  setFailed(true);
                } finally {
                  setRetrying(false);
                }
              }}
            >
              {retrying ? "Restoring your content…" : "Try again"}
            </button>
            <button
              className="rounded-md border px-5 py-3 font-medium"
              disabled={retrying}
              onClick={() => redirectToHandoffTool(error.toolUrl)}
            >
              Return to the tool
            </button>
          </div>
        </div>
      </div>
    );
  return (
    <div className="min-h-screen grid place-items-center p-6">
      <p role="status" className="text-sm text-muted-foreground">
        Returning you to the tool…
      </p>
    </div>
  );
}
